// import React from 'react'
// //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzY5NzQ2ODI3LCJpYXQiOjE3Njk3MTgwMjcsImp0aSI6IjQ3NmQ0NDc3YWRiMzRiMzk5MDU2NzFjZjU2YjNkYzE0IiwidXNlcl9pZCI6InVzcl9icGJISnlxNmtiWVo4ZiJ9.Sy53APaEDcZeb_Bf3nNzfBMwzwpFyM-H-Nbaoyxzq7Q
//  export const GetWorkFlows = (Token,callback) => {

// const myHeaders = new Headers();
// const cleanToken = Token.replace(/"/g, "");
// myHeaders.append("X-Token", cleanToken);
// console.log("Token used for fetching workflows:", Token);

// const requestOptions:any = {
//   method: "GET",
//   headers: myHeaders,
//   redirect: "follow"
// };

// fetch("https://staging-api.portant.dev/microsoft/addin/workflows/", requestOptions)
//   .then((response) => response.text())
//   .then((result) => {
//     console.log(result)
//     callback(result,null)})
//   .catch((error) => {
    
//     console.error(error)
//     callback(null,error)
// });
// }


/* global Office */

// Map the current Office host to the query param the API uses to only return
// workflows that contain a matching Microsoft document (Word tags can only be
// pasted into a Word document, and likewise for PowerPoint).
const getOfficeHost = (): string => {
  try {
    const host = (Office as any)?.context?.host;
    if (host === (Office as any)?.HostType?.Word) return "WORD";
    if (host === (Office as any)?.HostType?.PowerPoint) return "POWERPOINT";
  } catch (e) {
    // Office not ready or unavailable; fall back to any Microsoft document.
  }
  return "";
};

export const GetWorkFlows = (Token: string, callback: (data: any, error: any) => void) => {
  const myHeaders = new Headers();
  const cleanToken = Token.replace(/"/g, "");
  myHeaders.append("X-Token", cleanToken);
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  const host = getOfficeHost();
  const url = "https://api.portant.co/microsoft/addin/workflows/" + (host ? `?host=${host}` : "");

  fetch(url, requestOptions)
    .then(async (response) => {
      // 1. Get the response body as text first
      const resultText = await response.text();
      let resultData;
      
      try {
        // 2. Try to parse it as JSON
        resultData = JSON.parse(resultText);
      } catch (e) {
        resultData = resultText;
      }

      // 3. Check if HTTP status is 200-299
      if (!response.ok) {
        // This handles 500 Internal Server Error, 401 Unauthorized, etc.
        console.error("Server Error Response:", resultData);
        return callback(null, resultData);
      }

      // 4. Success case
      callback(resultData, null);
    })
    .catch((error) => {
      // Handles network failures
      console.error("Network Error:", error);
      callback(null, error);
    });
};